import { useQuery } from '@tanstack/react-query'
import { getOverrideRule } from '../../../api/plan-benefit-override-rules-api'

export const OVERRIDE_RULE_QUERY_KEY = 'overrideRule'

export function useGetOverrideRule(id: string | undefined) {
  return useQuery({
    queryKey: [OVERRIDE_RULE_QUERY_KEY, id],
    // queryFn only runs when `enabled` is true, which gates on `id` being set.
    queryFn: () => getOverrideRule(id ?? ''),
    enabled: Boolean(id),
    staleTime: 0,
  })
}
